import { Box } from '@mui/material';
import BunkeringDashboard from '../components/BunkeringDashboard/BunkeringDashboard';
import { PageTitle } from '../components/Page/PageTitle';
import { useTranslation } from 'react-i18next';
import { ROUTES_NS } from './i18n';

export const BunkeringDashboardRoute = () => {
  const { t } = useTranslation(ROUTES_NS);

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <PageTitle>{t('bunkeringDashboard')}</PageTitle>
      </Box>
      <BunkeringDashboard />
    </>
  );
};
